import PadraoModel from 'src/core/model/PadraoModel.js'

export default class OlxMarcaModel extends PadraoModel {
  recurso = 'olx/marcas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Marcas Olx';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
